import React from 'react';
import classNames from 'classnames';
import { loopPair } from 'twain-sport-fe-mono/utils';
import { IParticipantsPair, IParticipant, IScores } from 'twain-sport-fe-mono/interfaces';
import { ParticipantScore } from '../Participants';
import classes from './ParticipantsScore.module.scss';

interface IProps {
    participants: IParticipantsPair;
    scores: IScores;
    visible?: boolean;
    fullscreen?: boolean;
    className?: string;
}

export const ParticipantsScore: React.FC<IProps> = (props) => (
    <div
        className={classNames(
            classes.container,
            { [classes.visible]: props.visible, [classes.fullscreen]: props.fullscreen },
            props.className,
        )}
    >
        {loopPair<IParticipant>(props.participants).map((participant) => (
            <ParticipantScore
                key={participant.code}
                className={classes.score}
                value={props.scores[participant.code] || 0}
            />
        ))}
    </div>
);
